import { __assign } from "tslib";
import { WebXRExperienceHelper } from "./webXRExperienceHelper";
import { WebXRInput } from "./webXRInput";
import { WebXRControllerPointerSelection } from "./features/WebXRControllerPointerSelection";
import { WebXREnterExitUI } from "./webXREnterExitUI";
import { WebXRMotionControllerTeleportation } from "./features/WebXRControllerTeleportation";
import { Logger } from "../Misc/logger";
/**
 * Options for the default xr helper
 */
var WebXRDefaultExperienceOptions = /** @class */ (function () {
    function WebXRDefaultExperienceOptions() {
    }
    return WebXRDefaultExperienceOptions;
}());
export { WebXRDefaultExperienceOptions };
/**
 * Default experience which provides a similar setup to the previous webVRExperience
 */
var WebXRDefaultExperience = /** @class */ (function () {
    function WebXRDefaultExperience() {
    }
    /**
     * Creates the default xr experience
     * @param scene scene
     * @param options options for basic configuration
     * @returns resulting WebXRDefaultExperience
     */
    WebXRDefaultExperience.CreateAsync = function (scene, options) {
        if (options === void 0) { options = {}; }
        var result = new WebXRDefaultExperience();
        // Create base experience
        return WebXRExperienceHelper.CreateAsync(scene)
            .then(function (xrHelper) {
            result.baseExperience = xrHelper;
            if (options.ignoreNativeCameraTransformation) {
                result.baseExperience.camera.compensateOnFirstFrame = false;
            }
            // Add controller support
            result.input = new WebXRInput(xrHelper.sessionManager, xrHelper.camera, __assign({ controllerOptions: {
                    renderingGroupId: options.renderingGroupId,
                } }, (options.inputOptions || {})));
            result.pointerSelection = result.baseExperience.featuresManager.enableFeature(WebXRControllerPointerSelection.Name, options.useStablePlugins ? "stable" : "latest", {
                xrInput: result.input,
                renderingGroupId: options.renderingGroupId,
            });
            // Add default teleportation, including rotation
            if (!options.disableTeleportation) {
                result.teleportation = result.baseExperience.featuresManager.enableFeature(WebXRMotionControllerTeleportation.Name, options.useStablePlugins ? "stable" : "latest", {
                    floorMeshes: options.floorMeshes,
                    xrInput: result.input,
                    renderingGroupId: options.renderingGroupId,
                });
                result.teleportation.setSelectionFeature(result.pointerSelection);
            }
            // Create the WebXR output target
            result.renderTarget = result.baseExperience.sessionManager.getWebXRRenderTarget(options.outputCanvasOptions);
            if (!options.disableDefaultUI) {
                var uiOptions = __assign({ renderTarget: result.renderTarget }, (options.uiOptions || {}));
                if (options.optionalFeatures) {
                    if (typeof options.optionalFeatures === "boolean") {
                        uiOptions.optionalFeatures = ["hit-test", "anchors", "plane-detection", "hand-tracking"];
                    }
                    else {
                        uiOptions.optionalFeatures = options.optionalFeatures;
                    }
                }
                // Create ui for entering/exiting xr
                return WebXREnterExitUI.CreateAsync(scene, result.baseExperience, uiOptions).then(function (ui) {
                    result.enterExitUI = ui;
                });
            }
            else {
                return;
            }
        })
            .then(function () {
            return result;
        })
            .catch(function (error) {
            Logger.Error("Error initializing XR");
            Logger.Error(error);
            return result;
        });
    };
    /**
     * DIsposes of the experience helper
     */
    WebXRDefaultExperience.prototype.dispose = function () {
        if (this.baseExperience) {
            this.baseExperience.dispose();
        }
        if (this.input) {
            this.input.dispose();
        }
        if (this.enterExitUI) {
            this.enterExitUI.dispose();
        }
        if (this.renderTarget) {
            this.renderTarget.dispose();
        }
    };
    return WebXRDefaultExperience;
}());
export { WebXRDefaultExperience };
//# sourceMappingURL=webXRDefaultExperience.js.map